// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__EPCS6","padding":"panel_padding__Ol9Lg","numberContainer":"panel_numberContainer__tAVS6","number":"panel_number__eJfIz","content":"panel_content__p9qa6"};